import { ReactNode, useContext } from "react";
import { Navigate } from "react-router-dom";
import { MainContext } from "../AppContext";
import { hasAnyPermission, hasPermission, PermissionFlag } from "../constants/permissions";

type ProtectedRouteProps = { children: ReactNode } & (
  | { requiredPermission: PermissionFlag; anyOfPermissions?: never }
  | { anyOfPermissions: readonly PermissionFlag[]; requiredPermission?: never }
);

export default function ProtectedRoute({
  requiredPermission,
  anyOfPermissions,
  children,
}: ProtectedRouteProps) {
  const { user, userLoaded } = useContext(MainContext) as {
    user: any;
    userLoaded: boolean;
  };

  // While we are still determining the user's permissions, do not render nor redirect
  if (!userLoaded) {
    return <div>Loading...</div>; // Alternatively, return a spinner component
  }

  const allowed = anyOfPermissions
    ? hasAnyPermission(user?.permissions, anyOfPermissions)
    : hasPermission(user?.permissions, requiredPermission);

  if (!allowed) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
} 